var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"position-relative hero-section",attrs:{"color":"grey lighten-2"}},[(_vm.loading)?_c('LoadingWidget'):[(_vm.video.desktop)?_c('Video'):(_vm.slides.length)?_c('SlideShow'):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }